<template>
    <modal @close="$emit('close')" ref="modal">
        <template v-slot:title><span v-if="integration">Edit</span><span v-else>Add</span> POS Integration</template>

        <slot>
            <form-errors :errors="formErrors"/>

            <div class="form-row pb-2">
                <div class="col">
                    <form-input v-model="formData.pos" :errors="errors.pos" type="select" label="POS" :options="posOptions"/>
                </div>
            </div>

            <div class="form-row pb-2">
                <div class="col">
                    <form-input v-model="formData.label" :errors="errors.label" type="text" :nocaps="true" label="Label" />
                </div>
            </div>

            <div class="form-row pb-2">
                <div class="col">
                    <form-input v-model="formData.ref_code" :errors="errors.ref_code" type="text" :nocaps="true" label="Reference Code" :helper-text="'For referencing in Stores list'" />
                </div>
            </div>

            <div class="form-row pb-2" v-if="integration">
                <div class="col">
                    <form-input label="Default Integration" v-model="formData.apply_to_stores_default" :errors="errors.apply_to_stores_default" type="checkbox" :helper-text="'Apply to all stores in Client if no ref_code is set in Stores list'" />
                </div>
            </div>

            <div class="form-row pb-2" v-if="formData.pos === 'tcpplus'">
                <div class="col">
                    <form-input
                        label="Position field used for TCP+ jobCode composition"
                        v-model="formData.tcpplus_pos_value_field"
                        :errors="errors.tcpplus_pos_value_field"
                        type="select"
                        :options="tcpplusPosValueFieldOptions"
                        :helper-text="'pos_value_2 lets you stage a new TC+ tenant alongside the live integration. Use the live column (pos_value) for production traffic and pos_value_2 for the sandbox tenant.'"
                    />
                </div>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit()">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import api from '@/api'
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    mixins: [FormMixin, ModalMixin],
    props: ['client', 'integration', ],
    data() {
        const posOptions = [
            {text: 'Altametrics (LC)', value: 'lc_alt'},
            {text: 'Altametrics API (LC)', value: 'lc_alt_api'},
            {text: 'CaesarVision', value: 'lc'},
            {text: 'QSR', value: 'qsr'},
            {text: "CrunchTime (Culver's)", value: 'crunchtime'},
            {text: 'SICOM (BK)', value: 'sicom'},
            {text: 'NBO (Wingstop)', value: 'nbo'},
            {text: 'SynergySuite', value: 'synergy'},
            {text: 'Restaurant365', value: 'R365'},
            {text: 'Micros (Sonic)', value: 'micros_sonic'},
            {text: 'RTI', value: 'rti'},
            {text: 'TCPPlus', value: 'tcpplus'},
            {text: "FlexePOS (Jersey Mike's)", value: 'flexepos'},
        ]

        const rules = {
            pos: {presence: {allowEmpty: false}, },
            ref_code: {presence: {allowEmpty: false}, },
            label: {presence: {allowEmpty: false}, },
        }

        const tcpplusPosValueFieldOptions = [
            {text: 'pos_value (live)', value: 'pos_value'},
            {text: 'pos_value_2 (sandbox/migration)', value: 'pos_value_2'},
        ]

        return {
            dataLoaded: false,
            posOptions: posOptions,
            tcpplusPosValueFieldOptions: tcpplusPosValueFieldOptions,
            formRules: rules,
            formData: this.makeFormData(),
        }
    },
    mounted() {

    },
    methods: {
        makeFormData() {
            let formData
            if (this.integration) {
                formData = {
                    pos: this.integration.pos,
                    ref_code: this.integration.ref_code,
                    label: this.integration.label,
                    apply_to_stores_default: this.integration.apply_to_stores_default,
                    tcpplus_pos_value_field: this.integration.tcpplus_pos_value_field || 'pos_value',
                }
            } else {
                formData = {
                    pos: null,
                    ref_code: 'default',
                    label: 'Default Integration',
                    tcpplus_pos_value_field: 'pos_value',
                }
            }

            return formData
        },
        onSubmit() {
            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            if (this.integration) {
                // edit (PUT)
                let url = `/admin/clients/${this.client.id}/pos-integrations/${this.integration.id}/main`
                api.put(url, this.formData).then((resp) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('updated', resp)
                    this.close()
                }).catch((errors) => {
                    this.errors = errors
                    this.formErrors = errors.__all__
                    this.onError()
                    this.$store.dispatch('STOP_LOADING')
                })
            } else {
                // create (POST)
                let url = `/admin/clients/${this.client.id}/pos-integrations`
                api.post(url, this.formData).then((resp) => {
                    this.$store.dispatch('STOP_LOADING')
                    this.$emit('updated', resp)
                    this.close()
                }).catch((errors) => {
                    this.errors = errors
                    this.formErrors = errors.__all__
                    this.onError()
                    this.$store.dispatch('STOP_LOADING')
                })
            }
        },
    }
}
</script>
